// Track data structure
// Add your track information here
export const tracks = [
  {
    id: 1,
    name: "Majorana Fermion",
    album: "", // Optional: album or EP name
    playUrl: "https://youtu.be/HrnCuA-aW5A?si=2VgOwYtM3_Ym6KHj",
    lyrics: [], // Optional: lyrics as array of strings (each string is a line, empty string for blank line)
    platforms: {
      spotify: "https://open.spotify.com/track/0S7nxr6iWASzJQi1Gte5hH?si=3d75c6b9c951417f",
      appleMusic: "https://music.apple.com/cz/album/majorana-fermion-single/1841877413",
      youtube: "https://youtu.be/HrnCuA-aW5A?si=V19gLRqONRz1mT-j",
      tidal: "https://tidal.com/track/462675231",
      youtubeMusic: "https://music.youtube.com/watch?v=HrnCuA-aW5A&si=nNlaBlhsFykTRMDA"
    },
    artwork: "/track_img_1.jpeg"
  },
  {
    id: 2,
    name: "The Script",
    playUrl: "https://youtu.be/U_5Z_q9pRJc?si=sI4Oyyrwnk1jJNpM",
    lyrics: [
      "We're just running from ourselves in",
      "this big ambitious world",
      "Not a second to pretend that we're",
      "different cause we're told",
      "In this life you will survive only playing",
      "by the rules",
      "But the rules they were once made by",
      "the lost and scared fools",
      "",
      "Read their script",
      "Be so kind",
      "Your mission is so neat",
      "By them it was designed",
      "",
      "Repeat their thoughts",
      "Paraphrase the words",
      "So no one can see",
      "What's truly underneath",
      "",
      "Or they'll hunt you hunt you hunt you",
      "Till they got you got you",
      "And they'll blur out blur out blur out",
      "This poor man",
      "",
      "Man who loved and was a loved one",
      "Man who laughed and cried his eyes out",
      "Man who saw the beauty in the little things"
    ],
    platforms: {
      spotify: "https://open.spotify.com/track/2DYIami1ALZe0izrL2WDg2?si=e23244b0652c41d9",
      appleMusic: "https://music.apple.com/cz/album/the-script-single/1851687845",
      youtube: "https://youtu.be/U_5Z_q9pRJc?si=riItt2frw66GixtH",
      tidal: "https://tidal.com/track/472356432/u",
      youtubeMusic: "https://music.youtube.com/watch?v=U_5Z_q9pRJc&si=8klqtX6j12CUSOXr"
    },
    artwork: "/track_img_1.jpeg"
  },
  {
    id: 3,
    name: "Symbolic Price",
    playUrl: "https://youtu.be/JoqJUnwEJ7M?si=K4Q0E-eniXEQSdeL",
    platforms: {
      spotify: "https://open.spotify.com/track/2R2sNqwHaVxyIvB1zCdLzt?si=01b362d75ee24e9d",
      appleMusic: "https://music.apple.com/cz/album/symbolic-price-single/1859887141",
      youtube: "https://youtu.be/JoqJUnwEJ7M?si=Fm9UMfrq9bmW7JXY",
      tidal: "https://tidal.com/track/480297699/u",
      youtubeMusic: "https://music.youtube.com/watch?v=JoqJUnwEJ7M&si=tm03naCQwaWFlOK7"
    },
    artwork: "/track_img_1.jpeg"
  },
  {
    id: 4,
    name: "Expired Heart",
    playUrl: "https://youtu.be/Lwu9uQJT9cQ?si=IdKdATgRe3RfXBIS",
    platforms: {
      spotify: "https://open.spotify.com/track/5Ghlz1Hls8ypoEO9KceCG1?si=d0f7ee28482147bb",
      appleMusic: "https://music.apple.com/cz/album/expired-heart-single/1863375585",
      youtube: "https://youtu.be/Lwu9uQJT9cQ?si=pR6mNnaVrjoRZpLP",
      tidal: "https://tidal.com/track/484048055/u",
      youtubeMusic: "https://music.youtube.com/watch?v=Lwu9uQJT9cQ&si=4A9Vt6k3osZ-zfsH"
    },
    artwork: "/track_img_1.jpeg"
  },
  {
    id: 5,
    name: "New Track",
    comingSoon: true, // Set to true for tracks in progress
    artwork: "/track_img_1.jpeg"
  }
];

